import { useState } from "react";
import logo from "../Asset/GameshubLogo.PNG";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you for subscribing with ${email}!`);
    setEmail("");
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white mt-20 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-r from-red-600/10 to-purple-600/10"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={logo}
                alt={"GamesHub Logo"}
                className="h-24 object-cover flex-shrink-0"
              />
              <p className="text-gray-300 leading-relaxed">
                Your ultimate destination for video games and gaming
                accessories. We bring you the latest titles, unbeatable prices,
                and exceptional customer service.
              </p>
            </div>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-400">
                <span className="text-green-400">●</span>
                <span>24/7 Support</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-400">
                <span className="text-red-400">●</span>
                <span>Fast Shipping</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/products"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  Our Games
                </a>
              </li>
              <li>
                <a
                  href="/"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  New Releases
                </a>
              </li>
              <li>
                <a
                  href="/"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  Best Sellers
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">
              Customer Service
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/contact"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  Shipping Info
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  Returns & Exchanges
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition duration-200 flex items-center group"
                >
                  <span className="mr-2 group-hover:translate-x-1 transition duration-200">
                    →
                  </span>
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter & Social */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">
              Stay Connected
            </h4>

            {/* Newsletter */}
            <div className="mb-6">
              <p className="text-gray-300 text-sm mb-3">
                Get the latest updates and exclusive offers
              </p>
              <form onSubmit={handleNewsletterSubmit} className="space-y-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-red-600 to-purple-600 text-white py-2 px-4 rounded-md hover:shadow-lg transition duration-200 font-semibold transform hover:scale-105"
                >
                  Subscribe
                </button>
              </form>
            </div>

            {/* Social Media */}
            <div>
              <p className="text-gray-300 text-sm mb-3">
                Follow us on social media
              </p>
              <div className="flex space-x-3">
                <a
                  href="https://www.facebook.com/profile.php?id=100083751172233"
                  className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition duration-200 transform hover:scale-110"
                  title="Facebook"
                >
                  <span className="text-white text-lg">📘</span>
                </a>
                {/* <a
                  href="#"
                  className="w-10 h-10 bg-red-400 rounded-full flex items-center justify-center hover:bg-red-500 transition duration-200 transform hover:scale-110"
                  title="Twitter"
                >
                  <span className="text-white text-lg">🐦</span>
                </a> */}
                <a
                  href="https://www.instagram.com/gameshub14/"
                  className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition duration-200 transform hover:scale-110"
                  title="Instagram"
                >
                  <span className="text-white text-lg">📷</span>
                </a>
                <a
                  href="https://www.youtube.com/@gameshub-official/videos"
                  className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 transition duration-200 transform hover:scale-110"
                  title="YouTube"
                >
                  <span className="text-white text-lg">📺</span>
                </a>
                {/* <a
                  href="#"
                  className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition duration-200 transform hover:scale-110"
                  title="Discord"
                >
                  <span className="text-white text-lg">🎮</span>
                </a> */}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-wrap items-center space-x-6 mb-4 md:mb-0">
              <p className="text-gray-400 text-sm">
                &copy; 2023 GamesHub. All rights reserved.
              </p>
              <div className="flex space-x-4 text-sm">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition duration-200"
                >
                  Privacy Policy
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition duration-200"
                >
                  Terms of Service
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition duration-200"
                >
                  Cookie Policy
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <span className="text-green-400 text-sm">●</span>
                <span className="text-gray-400 text-sm">
                  All systems operational
                </span>
              </div>
            </div>
          </div>

          <div className="text-gray-400 text-center mt-2">
            Developed By{" "}
            <a
              href="https://www.linkedin.com/in/mohsin-ali-hussaini-6612161b3/"
              className="text-blue-400 hover:underline"
            >
              Mohsin Ali Hussaini
            </a>
          </div>

          {/* Trust Badges */}
          {/* <div className="mt-8 flex flex-wrap justify-center items-center space-x-6 text-gray-500 text-sm">
            <div className="flex items-center space-x-2">
              <span className="text-green-400">🔒</span>
              <span>SSL Secured</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-red-400">💳</span>
              <span>Secure Payments</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-purple-400">🚚</span>
              <span>Free Shipping $50+</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-orange-400">🔄</span>
              <span>30-Day Returns</span>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-gray-900 to-transparent"></div>
    </footer>
  );
};

export default Footer;
